// Shown on Q&A and freeform text sources, wherever they are written or read
// back.
//
// What the business writes itself wins over its website when the two
// disagree (functions/lib/brain.js), which makes these the way to correct an
// out-of-date site without editing it. That is only useful if people know it,
// so it is said where they are typing, not in a help page.

export const WRITTEN_WINS =
  "Wins over your website. If this disagrees with a page on your site, the bot goes with what you wrote here, so it's a good way to correct or add to your site without editing it.";

export default function WrittenWinsNote({ className = "" }: { className?: string }) {
  return (
    <p className={`text-xs text-slate-500 ${className}`} data-testid="written-wins">
      {WRITTEN_WINS}
    </p>
  );
}
